<!-- 仓库主数据 -->
<template>
  <div class="store">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      labelWidth="130px"
      :defaultRow="2"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @changeSupplyChainMethod="changeSupplyChainMethod"
      @changeProductTypeHandler="changeProductTypeHandler"
      @changeServiceTypeHandler="changeServiceTypeHandler"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :showFooter="true"
        :footerMethod="footerMethod"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <!-- 0512 客户名称常驻原因，去掉序号显示 -->
        <!-- <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column> -->
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <!-- <template v-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template> -->
            <!-- <template v-else-if="item.field === 'productType'">{{
              productList?.find((item) => item.value == row['productType'])?.label
            }}</template>
            <template v-else-if="item.field === 'serviceType'">{{
              serviceAllList?.find((item) => item.value == row['serviceType'])?.label
            }}</template> -->
            <template v-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <!-- <template v-else-if="item.field === 'multiBillingRuleFlag'">{{
              row.multiBillingRuleFlag == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'confirmStatus'">{{
              ['01'].includes(row.confirmStatus) ? '待确认' : '已确认'
            }}</template> -->
            <!-- <template v-else-if="item.field === 'abnormalExpenseFlag'">{{
              [0].includes(row.abnormalExpenseFlag) ? '否' : '是'
            }}</template> -->
            <!-- <template v-else-if="item.field === 'expenseNo'">
              <div style="color: #16a8e1; cursor: pointer">{{ row[item.field] }}</div>
            </template> -->
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- <SelectInstructionListDialog
      ref="SelectInstructionListDialog"
      @SelectInstructionHandler="SelectInstructionHandler"
    ></SelectInstructionListDialog>
    <AddExpenseDialog ref="AddExpenseDialog" @AddExpenseHandler="getTableData"></AddExpenseDialog> -->
    <el-upload
      style="display: none"
      ref="siruiUpload"
      :data="importData"
      :action="uploadUrl"
      accept=".xls,.xlsx"
      :before-upload="uploadBefore"
      :on-success="uploadSuccess"
      :show-file-list="false"
      :with-credentials="true"
      :on-error="uploadError"
    >
      <el-button ref="importBtn"></el-button>
    </el-upload>
    <AddAndEditCostDialog
      ref="AddAndEditCostDialogRef"
      @complete="costEditComplete"
    ></AddAndEditCostDialog>
    <batchCreateSettlementDialog
      ref="AddExpensesDialogRef"
      :showDialog="showBatchCreateSettlementDialog"
      :tableData="preSettlementTableData"
      @closeDialog="showBatchCreateSettlementDialog = false"
      @save="savePreGenerate"
    >
    </batchCreateSettlementDialog>
    <ExportBillDialog ref="exportBillDialogRef" />
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import API from '@/api/storeMasterData';
  import { searchColumns, defaultTableColumn, defaultMenuBtnList } from './index.js';
  // import tradeMixin from './../../mixin/tradeMixin';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import RECEIVABLES_PARKWAREHOUSE from '@/api/receivablesAndPayables/parkWarehouse.js';
  import expenseListMixin from './index.js';
  import AddAndEditCostDialog from './SettleAccountsDetail/components/AddAndEditCostDialog/index.vue';
  import batchCreateSettlementDialog from './components/batchCreateSettlementDialog.vue';
  import baseUrl from '@/common/config';
  import parkPropertyApi from '@/api/receivablesAndPayables/parkProperty.js';
  import ExportBillDialog from './ExportBillDialog/index.vue';
  // import SelectInstructionListDialog from './components/SelectInstructionListDialog/index.vue';
  // import AddExpenseDialog from './components/AddExpenseDialog/index.vue';
  export default {
    mixins: [expenseListMixin],
    name: 'ParkWarehouse',
    components: {
      SiruiSearch,
      SiruiTable,
      AddAndEditCostDialog,
      batchCreateSettlementDialog,
      // SelectInstructionListDialog,
      // AddExpenseDialog,
      ExportBillDialog,
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      expenseType() {
        return this.dictListMap.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      // 公路服务
      highwayList() {
        return this.serviceList.slice(0, 6);
      },
      railwayList() {
        return this.serviceList.slice(6);
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        importUrl: '',
        uploadUrl: '',
        importData: {}, //导入参数
        showBatchCreateSettlementDialog: false,
        preSettlementTableData: [],
        columnList: [],
        // query: {
        //   pageNum: 1,
        //   pageSize: 10,
        //   expenseNo: '',
        //   businessCompanyNo: '',
        //   businessDepartmentCode: '',
        //   processStatus: null,
        //   expenseTypeList: [],
        //   businessDocCodeLike: '',
        //   productType: '',
        //   serviceType: '',
        //   businessCategory: '02',
        //   accountPeriod: '',
        //   expenseGenerationDateStart: '',
        //   expenseGenerationDateEnd: '',
        //   abnormalExpenseFlag: '',
        //   confirmStatus: '',
        //   customerNo: '',
        //   contractNo: '',
        //   createMethod: '',
        //   originalAmountStart: '',
        //   originalAmountEnd: '',
        //   salesmanNo: '',
        // },
      };
    },
    methods: {
      SelectInstructionHandler(val) {
        console.log(val, '选择-------------》');
        this.$refs.AddExpenseDialog.selectInstructionDetailList = val;
        setTimeout(() => {
          this.$refs.AddExpenseDialog.openDialog();
        }, 100);
      },
      AddExpenseHandler(val) {
        console.log(val);
      },
      footerMethod({ columns }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (columnIndex === 3) {
              return `原币结算金额（含税） `;
            } else if (columnIndex === 5) {
              return `本币结算金额（含税）`;
            }
            return null;
          }),
        ];
      },
      savePreGenerate() {
        this.showBatchCreateSettlementDialog = false;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log(selection);
        const originalAmount = selection.reduce((prev, cur) => prev + +cur.originalAmount, 0);
        const domesticAmount = selection.reduce((prev, cur) => prev + +cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(originalAmount).toFixed(2),
          this.$globalVar.qPoint
        );
        totalDom2.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(domesticAmount).toFixed(2),
          this.$globalVar.qPoint
        );
        // this.$utils.commafy(this.$utils.toNumber(total).toFixed(2), point)
      },
      // ExpenseListDetail({ row }) {
      //   console.log(row, '费用清单详情');
      //   let { id, serviceType, confirmStatus } = row;
      //   let path = {
      //     path: '/receivablesAndPayables/multimodalTransportExpenseListYSDetail',
      //     name: 'multimodalTransportExpenseListYSDetail',
      //     meta: {
      //       keepAlive: true,
      //       title: '应收费用详情',
      //     },
      //     query: { id, serviceType, confirmStatus },
      //   };
      //   this.$store.dispatch('tagsView/addTabView', path).then(() => {
      //     this.$nextTick(() => {
      //       this.$router.push(path);
      //     });
      //   });
      // },

      // 切换供应商
      changeSupplyChainMethod(val) {
        console.log(val, '修改客户');
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerNo: rowData?.partnerCode,
        };
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 修改投送人
      changeDelivererNameMethod(val) {
        console.log(val, '修改同送人');
        this.query.delivererNo = val[0]?.personNo || '';
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.personNo || '';
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '应收查看按钮列表');
          // this.menuButtonList = e;
          this.menuButtonList = defaultMenuBtnList;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn;
        });
      },
      costEditComplete() {
        this.resetBtnClickHandler();
      },
      // 获取表格数据
      async getTableData(search) {
        console.log(search, '搜索');
        // this.tableData = this.mockDataList;
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLESEXPENSE_QUERY,
          postData
        );
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data?.records;
        this.tableData.forEach((item) => {
          item.domesticAmount = item.domesticAmount ? item.domesticAmount.toFixed(2) : '0.00';
          item.originalAmount = item.originalAmount ? item.originalAmount.toFixed(2) : '0.00';
        });
        this.$refs.siruiTable.setPageTotal(data.data?.total);
      },
      // 表格上面的按钮
      async chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          const selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.filter((item) => item.processStatus == 1);
          // let confirmStatusList = selectedList.filter((item) =>
          //   ['01'].includes(item.confirmStatus)
          // );
          console.log(processStatusList, 'processStatusList');
          if (processStatusList.length > 0) {
            this.$message.error('已处理的费用清单不能再次创建');
            return;
          }
          // if (confirmStatusList.length > 0) {
          //   this.$message.error('待确认状态的费用单不可生成对账单，需要先进行草稿确认');
          //   return;
          // }
          let orderCodeList = [];
          // let orderCodeStatus = null;
          let contractNoList = [];
          let customerNoList = [];
          let contractNoStatus = null;
          let customerNoStatus = null;
          let ids = [];
          selectedList.map((item) => {
            orderCodeList.push(item.orderCode);
            contractNoList.push(item.contractNo);
            customerNoList.push(item.customerNo);
            ids.push(+item.id);
          });
          console.log(ids, 'idssssssssssss');
          // orderCodeStatus = this.isAllEqual(orderCodeList);
          contractNoStatus = this.isAllEqual(contractNoList);
          customerNoStatus = this.isAllEqual(customerNoList);
          // console.log(productNameList, 'productNameList');
          // console.log(productNameStatus, 'productNameStatus');
          // console.log(contractNoList, 'contractNoList');
          // console.log(contractNoStatus, 'contractNoStatus');

          if (!contractNoStatus) {
            this.$message.error('所选合同不一致');
            return;
          }
          if (!customerNoStatus) {
            this.$message.error('所选客户不一致');
            return;
          }

          let path = {
            path: '/receivablesAndPayables/parkWarehouseReceivablesDetail',
            name: 'parkWarehouseReceivablesDetail',
            meta: {
              keepAlive: true,
              title: '园区仓储应收结算',
            },
            query: {
              status: 'create',
              id: ids,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'export') {
          const selectedList = this.$refs.siruiTable.getCheckboxRecords();
          if (selectedList.length > 0) {
            const postData = [];
            selectedList.map((item) => {
              postData.push(item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT, {
              ids: postData,
              businessCategory: this.query?.businessCategory,
            });
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          } else {
            const postData = this.query;
            const { data } = await this.$axios.post(
              RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT,
              postData
            );
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error('导出失败');
            }
          }
        } else if (type == 'download') {
          this.downExcelTemplate('093');
          // this.$refs.SelectInstructionListDialog.openDialog();
        } else if (type == 'delete') {
          console.log('删除');
          const selectedList = this.$refs.siruiTable.getCheckboxRecords();
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.map((item) => [1].includes(item.processStatus));
          if (processStatusList.length > 0) {
            this.$message.error('所选择的数据包含不可删除的数据，请确认');
            return;
          }
          this.$confirm('确定要删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const postData = [];
              selectedList.map((item) => {
                postData.push(+item.id);
              });
              const { data } = await this.$axios.post(
                RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_DELETE_API,
                {
                  ids: postData,
                  // oaId: this.userInfo.userInfo.oaId,
                }
              );
              if (data.code === 0) {
                this.$message.success('删除成功');
                this.queryBtnClickHandler();
              } else {
                this.$message.error(`${data.msg}`);
              }
            })
            .catch(() => {});
        } else if (type == 'enable') {
          this.importBtnClickHandler();
        } else if (type == 'createBill') {
          this.$refs.AddAndEditCostDialogRef.openModal();
        } else if (type == 'editBill') {
          // TODO 判断必须要选择行才可以跳转
          const selectedList = this.$refs.siruiTable.getCheckboxRecords();
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.filter((item) => item.processStatus == 1);
          console.log(processStatusList, 'processStatusList');
          if (processStatusList.length > 0) {
            this.$message.error('已处理的费用清单不能再次创建');
            return;
          }
          let contractNoStatus = null;
          let contractNoList = [];
          selectedList.map((item) => {
            contractNoList.push(item.contractNo);
          });

          contractNoStatus = this.isAllEqual(contractNoList);

          if (!contractNoStatus) {
            this.$message.error('所选合同不一致');
            return;
          }

          this.$refs.AddAndEditCostDialogRef.openModal([...selectedList]);
        } else if (type == 'batchCreate') {
          this.batchCreate();
        } else if (type == 'exportBill') {
          const selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          const customerNoList = [...new Set(selectedList.map((item) => item.customerNo))];
          if (customerNoList.length > 1) {
            this.$message.error('只能选择一个客户编号的');
            return;
          }
          const contractNoList = [...new Set(selectedList.map((item) => item.contractNo))];
          if (contractNoList.length > 1) {
            this.$message.error('只能选择一个合同编号的');
            return;
          }
          this.$refs.exportBillDialogRef.openModal(selectedList);
        }
      },
      // 批量生成
      async batchCreate() {
        const selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作');
          return;
        }
        let processStatusList = selectedList.filter((item) => item.processStatus == 1);

        if (processStatusList.length > 0) {
          this.$message.warning('已处理的费用清单不能再次创建');
          return;
        }
        let expenseIds = selectedList.map((item) => item.id);

        const { data } = await this.$axios.post(
          parkPropertyApi.RECEIVABLESEXPENSE_PREGENERATE_SETTLEMENT,
          {
            businessGroup: '园区',
            expenseIds: expenseIds,
          }
        );
        if (data.code == 0) {
          this.preSettlementTableData = data.data;
          this.showBatchCreateSettlementDialog = true;
        } else {
          if (data.msg != null) {
            return this.$message.error(data.msg);
          }
          return this.$message.error('操作失败');
        }
      },

      // 导入
      importBtnClickHandler() {
        this.$refs.importBtn.$el.click();
        this.setImport();
      },
      // 设置导入配置
      setImport() {
        this.uploadUrl = baseUrl + '/' + RECEIVABLES_PARKWAREHOUSE.ENABLE;
        // const { contractNo } = this.baseFormData;
        this.importData = {
          access_token: this.userInfo.access_token,
          // selectContractStr: contractNo,
          salesmanNo: this.userInfo.personNo,
          salesmanName: this.userInfo.personName,
          businessCompanyNo: this.query.businessCompanyNo,
          businessCompanyName: this.businessCompanyName,
          businessDepartmentCode: this.query.businessDepartmentCode,
          businessDepartmentName: this.businessDepartmentName,
        };
      },
      // 开始上传
      uploadBefore() {
        // this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        // this.loading.endLoading();
        if (response.code === 0) {
          // if (response.data.length < 1) {
          //   this.$message.error('不支持的文件内容');
          //   return;
          // }
          this.$message.success('导入成功');
          this.getTableData();
          // this.$emit('importData', response.data);
        } else {
          this.$message.error(`${response.msg}`);
        }
      },
      // 上传错误
      uploadError() {
        // this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      //判断数组里元素是否全相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },

      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        console.log(this.userInfo?.departmentCode, '搜索this.userInfo?.departmentCode');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        console.log(this.userInfo?.departmentCode, '重置this.userInfo?.departmentCode');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.query = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo?.departmentCode,
        };
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
